var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cbutton group",class:[_vm.sizeClasses, _vm.modeClasses, _vm.custom, _vm.isLoading, {'!cursor-not-allowed': _vm.disabled}]},[_c('base-icon',{attrs:{"name":_vm.name,"size":_vm.iconSize,"title":_vm.titleIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }